export default {
  action: 'Action',
  actionBlockedDueToDuplicateUuid:
    "Action bloquée en raison d'un UUID de périphérique en double",
  active: 'Actif',
  add: 'Ajouter',
  addAnotherIp: 'Ajouter une autre adresse IP',
  addDeviceHeaderwoSuite: 'Ajouter des équipements: {{screen}}',
  addDevices: 'Ajouter un équipement',
  addIp: 'Ajouter une IP',
  addIPAddress: 'Ajouter une adresse IP',
  addIpHeader: 'Ajouter une adresse IP: {{screen}}',
  addRole: 'Ajouter un rôle',
  addSuite: 'Ajouter une suite',
  addSuiteHeader: 'Ajouter une suite: {{screen}} - Suite {{suite}}',
  adminRoleWillHaveFullAccess: 'Le rôle Administrateur aura un accès complet',
  all: 'Tous',
  and: 'et',
  applianceStatus: "État de l'équipement",
  apply: 'Appliquer',
  assignedToDevice: "Assigné à l'équipement",
  availableDevices: 'Équipements disponibles',
  bookingDate: 'Date de réservation',
  bookingRef: 'Réf. de réservation',
  bulkEditScreenIPs: "Modification en masse des IP d'écran",
  bulkHeadingMsg:
    "Les modifications apportées aux adresses IP ici seront répercutées sur tous les équipements d'écran associés.",
  cancel: 'Annuler',
  ccEmails: 'E-mails en CC',
  certificateAutoSync: 'Synchronisation automatique des certificats',
  certificateExpired: 'Certificat expiré',
  certificateForAllDevicesMustBeValid:
    'Le certificat de tous les équipements doit être valide',
  certificateNotAvailable:
    "Certificat d'équipement indisponible pour ce numéro de série.",
  certificateNotValid: 'Certificat non valide',
  chain: 'CHAÎNE',
  chainSmall: 'Chaîne',
  changesSavedSuccessfully: 'Modifications enregistrées avec succès',
  clear: 'Effacer',
  clearAll: 'Tout effacer',
  clearAllSmall: 'Tout effacer',
  clearSelection: 'Effacer la sélection',
  collapseAll: 'Tout réduire',
  common: {
    confirm: 'Confirmer',
  },
  composition: 'Composition',
  compositionCount_one: 'Composition (1)',
  compositionCount_other: 'Compositions ({{count}})',
  compositionDetails: 'Détails de la composition',
  compositionName: 'Nom de la composition',
  confirmDelete: 'Confirmer la suppression',
  confirmDeleteIP: "Êtes-vous sûr de vouloir supprimer l'adresse IP {{ip}} ?",
  confirmDeleteIPAssigned:
    "Cette IP est actuellement assignée et sera déconnectée de l'équipement : {{deviceInfo}} à {{location}}.",
  confirmDeleteSuite:
    'Êtes-vous sûr de vouloir supprimer {{screen_name}} - Suite {{suite_number}} ? Veuillez choisir une option appropriée pour continuer.',
  content: 'Contenu',
  contentDetails: 'Détails du contenu',
  copyLink: 'Copier le lien',
  countTheatres_one: '1 Cinéma',
  countTheatres_other: '{{count}} Cinémas',
  cplMarkers: 'Marqueurs CPL',
  create: 'Créer',
  createdOn: 'Créé le',
  creditOffset: 'Décalage de crédit',
  creditsOffset: 'Décalage de crédits',
  dcpStatusTitle: 'Statut du DCP',
  deactivatedUser: 'Utilisateur désactivé',
  delete: 'Supprimer',
  deleteIp: "Supprimer l'IP",
  deleteIpTitle: "Supprimer l'adresse IP - {{ip}}",
  deleteSuite: 'Supprimer la suite',
  deleteTheatreGroup: 'Supprimer le groupe de cinémas',
  deleteTheatreGroupConfirmation:
    'Êtes-vous sûr de vouloir supprimer {{groupName}} ? Cette action est permanente et ne peut pas être annulée.',
  deleteTheatreWarningMessage:
    'La suppression affectera leur accès, êtes-vous sûr de vouloir continuer ?',
  details: 'Détails',
  deviceModel: "Modèle d'équipement",
  deviceRole: "Rôle d'équipement",
  devices: 'Équipements',
  deviceWillBeMoved:
    "L'équipement sera déplacé vers les équipements de l'Écran {{destination}} après l'enregistrement",
  deviceWillBeMovedToStandby: "L'équipement sera déplacé en veille",
  deviceWillBeRemoved: "L'équipement sera retiré de cette suite",
  disabled: 'Désactivé',
  doNotIncludePrDevices:
    "NE PAS inclure d'équipements PR pour la génération de KDM.",
  downloadAttempt: 'Tentative de téléchargement',
  downloadDetails: 'Détails du téléchargement',
  downloadHistory: 'Historique des téléchargements',
  downloadKDMs: 'Télécharger les KDM',
  downloadLocation: 'Emplacement du téléchargement',
  downloadNow: 'Télécharger maintenant',
  downloadProgress: '{{progress}} Terminé',
  downloadSize: 'Taille du téléchargement',
  downloadStatus: 'Statut du téléchargement',
  duplicateDeviceFound: 'Équipement en double détecté',
  duplicateDeviceWarning:
    'Équipement en double trouvé dans {{screens_and_suites}}',
  editDevice: "Modifier l'équipement",
  editDeviceMeta: "Modifier les métadonnées de l'équipement",
  editIp: "Modifier l'IP",
  editIpHeader: "Modifier l'IP - Écran {{screen}}",
  editRoles: 'Modifier les rôles',
  editSuite: 'Modifier la suite',
  editSuiteHeader: 'Modifier la suite: Écran {{screen}} - Suite {{suite}}',
  editTheatreGroup: 'Modifier le groupe de cinémas',
  effectiveFrom: 'Effectif à partir du',
  email: 'E-mail',
  emailKDMS: 'Envoyer les KDM par e-mail',
  emptyScreen: "Aucune suite ajoutée à l'écran",
  emptyStandby: 'Aucun équipement en veille',
  enabled: 'Activé',
  enterEmail: "Entrer l'e-mail",
  enterGateway: 'Entrer la passerelle',
  enterIpAddress: "Entrer l'adresse IP",
  enterSoftwareVersion: 'Entrer la version du logiciel',
  enterSubnetMask: 'Entrer le masque de sous-réseau',
  errorDownloadingKDMs: 'Erreur lors du téléchargement du KDM',
  errorFetching: 'Erreur lors de la récupération des données',
  errorFetchingDevices: 'Erreur lors de la récupération des équipements',
  errorFetchingFilterSettings:
    'Erreur lors de la récupération des paramètres de filtre',
  errorFetchingGroups: 'Erreur lors du chargement de la liste des groupes',
  errorFetchingUser:
    "Erreur lors du chargement des informations de l'utilisateur",
  errorFetchingUsersList:
    'Erreur lors du chargement de la liste des utilisateurs',
  errorFetchingWireTapCount:
    'Erreur lors du chargement du nombre total de WireTAPs',
  errorLoadingWireTap: 'Erreur lors du chargement des WireTAPs',
  errorMessage: "Une erreur s'est produite lors du traitement de votre demande",
  errorReportDownload:
    'Erreur lors du téléchargement du rapport {{report}} : {{error}}',
  errors: {
    fetchDeviceModels:
      "Erreur lors de la récupération des modèles d'équipements",
    fetchDeviceRoles: "Erreur lors de la récupération des rôles d'équipements",
    fetchTheatreInfo:
      'Erreur lors de la récupération des informations du cinéma',
  },
  errorUploadingCertificate: 'Erreur lors du téléchargement du certificat',
  expandAll: 'Tout développer',
  expired: 'Expiré',
  expiredOn: 'Expiré le',
  expiring: 'Expire (dans {{days}} jours)',
  expiring_1: 'En expiration',
  expiryOn: "Date d'expiration le",
  failedToDeleteTheatreGroup: 'Échec de la suppression du groupe de cinémas',
  failedToDeleteTheatreGroupMessage:
    "Une erreur s'est produite lors de la suppression du groupe de cinémas",
  failedToRemoveUser: "Échec de la suppression de l'utilisateur",
  failedToSendUserInvite: "Échec de l'envoi de l'invitation à l'utilisateur",
  failedToUpdateUser: "Échec de la mise à jour de l'utilisateur",
  fetchCompositions: 'Erreur lors du chargement des compositions',
  fetchingRoles: 'Récupération des rôles...',
  fetchTheatres: 'Erreur lors du chargement des cinémas',
  filter: 'Filtrer',
  filterBy: 'Filtrer par',
  filterByTheatres: 'Filtrer par cinémas',
  filterPanelCompositionType: 'TYPE DE COMPOSITION',
  filterPanelCompositionTypeOptions_advertisement: 'Publicité',
  filterPanelCompositionTypeOptions_feature: 'Film / Long métrage',
  filterPanelCompositionTypeOptions_others: 'Autres',
  filterPanelCompositionTypeOptions_psaPolicy: 'PSA / Politique',
  filterPanelCompositionTypeOptions_trailerTeaserPromo:
    'Bande-annonce / Teaser / Promo',
  filterPanelDcpDownloadStatus: 'STATUT DU TÉLÉCHARGEMENT DCP',
  filterPanelDcpIngestStatus: "STATUT D'INGESTION DCP",
  filterPanelKdmIngestStatus: "STATUT D'INGESTION KDM",
  filterPanelKdmStatus: 'STATUT DE LIVRAISON KDM',
  filterPanelKdmValidity: 'VALIDITÉ KDM',
  filterPanelTheatresPlaceHolder: 'Rechercher des cinémas',
  filterPanelTheatresTitle: 'CINÉMAS',
  filters: 'Filtres',
  from_time_of_booking: 'à partir du moment de la réservation.',
  fullAccess: 'Accès complet',
  future: 'Valide dans le futur',
  gateway: 'Passerelle',
  generateReport: 'Générer un rapport',
  groupCount_one: '{{count}} Groupe',
  groupCount_other: '{{count}} Groupes',
  groupName: 'Nom du groupe',
  groupsCreateGroupCancel: 'Annuler',
  groupsCreateGroupCreateTheatreGroups: 'Créer des groupes de cinémas',
  groupsCreateGroupGroupCreated: 'Groupe créé',
  groupsCreateGroupGroupName: 'Nom du groupe',
  groupsCreateGroupGroupPlaceHolderName: 'Entrer le nom du groupe',
  groupsCreateGroupHeaderTitle: 'Créer un groupe',
  groupsCreateGroupSaveChanges: 'Enregistrer les modifications',
  groupsCreateGroupTheatreSelection: 'Sélection des cinémas',
  groupsHeaderCreateTheatreGroupButton: 'Créer un groupe de cinémas',
  groupsHeaderViewLogsButton: 'Voir les journaux',
  groupUpdated: 'Groupe mis à jour',
  holdoverKdmRequests: 'Demandes de prolongation KDM (Holdover)',
  hour: 'Heure',
  iabScreens: 'Écrans IAB',
  inbox: 'Boîte de réception',
  invalidEmail: 'Adresse e-mail non valide',
  ipAddress: 'Adresse IP',
  ipAddress_1: 'ADRESSE IP',
  ipAlreadySelectedInForm:
    'Cette IP est déjà sélectionnée/assignée. Veuillez sélectionner une autre IP.',
  ipCount_one: 'IP (1)',
  ipCount_other: 'IPs ({{count}})',
  ipRequired: "L'adresse IP est requise",
  kdmDetails: 'Détails de la KDM',
  kdmValidityTheatreTimeZone: 'Validité KDM (Fuseau horaire du cinéma)',
  lastUpdatedBy: 'Dernière mise à jour par',
  lastUpdatedOn: 'Dernière mise à jour le',
  linkExpiredOnDownload:
    "Le téléchargement ne peut pas démarrer. Le lien de livraison est expiré ou n'est plus éligible au téléchargement.",
  linkReceivedOn: 'Lien reçu le',
  loading: 'Chargement',
  location: 'Emplacement',
  logsTheatreGroups: 'Journaux : Groupes de cinémas',
  minute: 'Minute',
  moveModalText: "L'équipement {{name}} sera déplacé en veille, continuer ?",
  moveTo: 'Déplacer vers',
  moveToScreen: 'Écran {{number}}',
  moveToStandby: 'Placer en veille',
  moveToStandbyDevices: 'Déplacer vers les équipements en veille',
  moveToUnmapped: "Déplacer vers les équipements de l'Écran {{number}}",
  movie: 'Film',
  movieName: 'Nom du film',
  multiThumbprintKdm: 'Écrans KDM multi-empreintes avec serveur DC2 (DCP 2000)',
  multiThumbprintKdmOtherServices:
    "Écrans KDM multi-empreintes avec d'autres serveurs",
  name: 'Nom',
  needs_1_SM_RMB_msg:
    'Chaque suite doit contenir exactement 1 SM/1 RMB. Veuillez ajouter un équipement SM/RMB avec certificat pour continuer',
  newData: 'Nouvelles données',
  newRequestCreated:
    "Une nouvelle demande a été créée avec l'ID de demande {{requestId}}.",
  no_compositions: 'Aucune composition',
  no_theatres: 'Aucun cinéma disponible',
  noAccess: 'Aucun accès',
  noBookings: 'Aucune réservation disponible',
  noData: 'Aucune donnée',
  noExpiredBookings: 'Aucun téléchargement WireLink expiré trouvé.',
  noIpFound: 'Aucune IP disponible',
  noMatchFound: 'Aucun résultat trouvé',
  normalKdm: 'KDM normale',
  noResultsFound: 'Aucun résultat trouvé',
  notDownloaded: 'Non téléchargé',
  notSelected: 'Non sélectionné',
  noWiretapAvailable: 'Aucun WireTAP disponible',
  oldData: 'Anciennes données',
  optional: 'Optionnel',
  osVersion: "VERSION DE L'OS",
  pending: 'En attente',
  readyToDownload: 'Prêt à télécharger',
  receivedOn: 'Reçu le',
  recipientDetails: 'Détails du destinataire',
  recipientEmails: 'E-mails des destinataires',
  remove: 'Retirer',
  removeDevice: "Supprimer l'équipement",
  removeFromTheatre: 'Retirer du cinéma',
  removeModalText: 'Êtes-vous sûr de vouloir retirer {{name}} du cinéma ?',
  removeUser: "Supprimer l'utilisateur",
  removeUserConfirmation:
    "La suppression de cet utilisateur retirera son accès de cette entreprise. L'utilisateur ne pourra plus se connecter ni effectuer d'actions.",
  reportInitiated: 'Le rapport {{report}} est initialisé.',
  reportReady: 'Le rapport {{report}} est prêt.',
  reportsheaderTitle: 'Rapports',
  requestedBy: 'Demandé par',
  requestedKdmValidity: 'Validité KDM demandée',
  requestedOn: 'Demandé le',
  requestFailed: 'Échec de la demande',
  requestFailedMessage: "Échec de l'envoi de la demande. Veuillez réessayer.",
  requestSent: 'Demande envoyée',
  role: 'Rôle',
  roles: 'Rôles',
  save: 'Enregistrer',
  saveChanges: 'Enregistrer les modifications',
  screen: 'Écran',
  screenInactive: 'Inactif',
  screens: 'Écrans',
  searchByLocation: 'Rechercher par emplacement',
  searchByNameOrEmail: 'Rechercher par nom ou e-mail',
  searchBySerialNo: 'Rechercher par numéro de série',
  searchByTheatreGroup: 'Rechercher par groupe de cinémas',
  searchByTheatreGroupName: 'Rechercher par nom de groupe de cinémas',
  searchByTheatreName: 'Rechercher par nom de cinéma',
  searchCompositions: 'Rechercher par nom de composition',
  searchCompositionsPlaceholder: 'Rechercher des compositions',
  searchDeviceModel: "Rechercher un modèle d'équipement",
  searchForChain: 'Rechercher une chaîne',
  searchForLocation: 'Rechercher un emplacement',
  searchForOsVersion: "Rechercher une version d'OS",
  searchForPublicIp: 'Rechercher une IP publique',
  searchForSerialNumber: 'Rechercher un numéro de série',
  searchForTheatre: 'Rechercher un cinéma',
  searchForWiretap: 'Rechercher un WireTAP',
  searchMovies: 'Rechercher par nom de film',
  searchPlaceholder: 'Rechercher les cinémas que vous gérez',
  searchSerialNumber: 'Rechercher un numéro de série',
  searchTheatres: 'Rechercher par nom de cinéma',
  selectIpAddress: 'Sélectionner une adresse IP',
  selectRole: 'Sélectionner un rôle',
  sendInvite: "Envoyer l'invitation",
  serialNumber: 'Numéro de série',
  serialNumber_1: 'NUMÉRO DE SÉRIE',
  show: 'Afficher',
  showingCountResults_one: 'Affichage de 1 résultat pour',
  showingCountResults_other: 'Affichage de {{count}} résultats pour',
  showingResults: 'Affichage de {{start}} à {{end}} sur {{total}} éléments',
  showingResultsFor: 'Affichage des résultats pour',
  showMore: 'Afficher plus',
  softwareVersion: 'Version logicielle',
  somethingWentWrong: "Une erreur s'est produite",
  standby: 'Veille',
  standbyDevices: 'Équipements en veille',
  standbyHeader_one: 'Équipements en veille (1)',
  standbyHeader_other: 'Équipements en veille ({{count}})',
  status: 'Statut',
  subnetMask: 'Masque de sous-réseau',
  suite: 'Suite',
  suiteCreationRules: 'Règles de création de suite',
  suiteDevicesExpiredMsg:
    'La suite contient des équipements avec des certificats expirés',
  suiteEffectiveFrom: 'Suite effective à partir du',
  suiteInvalid: 'Suite non valide pour la génération de KDM',
  suiteLogs: 'Journaux de la suite',
  suiteMustContain:
    'La suite doit contenir exactement {{smCount}} équipement SM ou {{rmbCount}} équipement RMB.',
  suiteMustContainAdLd:
    "La suite doit contenir au moins 1 équipement supplémentaire ayant le rôle d'équipement LD",
  suiteMustContainLDorPR:
    "La suite doit contenir au moins 1 équipement supplémentaire ayant le rôle d'équipement LD ou PR.",
  suiteMustContainSm:
    'La suite doit contenir exactement {{smCount}} équipement SM.',
  suiteMustContainSMOBE:
    'La suite doit contenir exactement 1 équipement SM / OBAE avec SM.',
  suiteNo: 'Suite {{number}}',
  theatre: 'Cinéma',
  theatre_1: 'CINÉMA',
  theatre_header: 'Cinéma',
  theatreCount: 'Nombre de cinémas',
  theatreGroup: 'Groupe de cinémas',
  theatreGroupDeleted: 'Groupe de cinémas supprimé',
  theatreGroupDeletedMessage: 'Le groupe {{groupName}} a été supprimé',
  theatreGroupDetails: 'Détails du groupe de cinémas',
  theatreGroups: 'Groupes de cinémas',
  theatreName: 'Nom du cinéma',
  theatres: 'Cinémas',
  theatresList: 'Liste des cinémas',
  theatreSmall: 'Cinéma',
  theatreTimeZone: 'Fuseau horaire du cinéma',
  trackingInfo: 'Informations de suivi',
  unarchival_may_take: 'Désarchivage peut prendre',
  undo: 'Annuler',
  unmappedDevices_one: 'Équipement (1)',
  unmappedDevices_other: 'Équipements ({{count}})',
  untitled: 'Sans titre',
  update: 'Mettre à jour',
  updatedBy: 'Mis à jour par',
  updatedOn: 'Mis à jour le',
  uploadCertificate: 'Téléverser le certificat',
  uploadDeviceCertificate: "Téléverser le certificat d'équipement",
  user: 'Utilisateur',
  userCount_one: '1 Utilisateur',
  userCount_other: '{{count}} Utilisateurs',
  userInviteSent: 'Invitation utilisateur envoyée avec succès',
  userLogs: "Journaux de l'utilisateur",
  userRemoved: 'Utilisateur supprimé',
  users: 'Utilisateurs',
  usersHeaderButtonsInviteUser: 'Inviter un utilisateur',
  usersHeaderButtonsViewLogs: 'Voir les journaux',
  usersHeaderTitle: 'Gérer les utilisateurs',
  validFrom: 'Valide du',
  validNow: 'Valide actuellement',
  validTo: "Valide jusqu'au",
  verificationStatus: 'Statut de vérification',
  viewAll: 'Tout afficher',
  viewAllTheatreGroups: 'Voir tous les groupes de cinémas',
  viewCreditOffset: 'Crédits : {{value}}',
  viewSuiteLogs: 'Voir les journaux de la suite',
  viewTheatreGroup: 'Voir le groupe de cinémas',
  warning: 'Avertissement',
  wireLinkCopiedToClipboard: 'WireLink copié dans le presse-papiers',
  wireLinkCopyFailed: 'Impossible de copier, veuillez réessayer',
  wireLinkDetails: 'Détails du WireLink',
  wireLinks: 'WireLinks',
  wiretaps: 'WireTAPs',
  wiretapStatusReport: "Rapport d'état WireTAP",
  appliances: 'Appareils',
  noResultsFor: 'Aucun résultat pour',
  city: 'Ville',
  province: 'Province',
  country: 'Pays',
  confirmAction: 'Confirmer l’action',
  RequestId: 'ID de demande : {{requestId}}',
  moveToUnmapped_name: 'Déplacer vers les équipements {{name}}',
  language: 'Langue',
  subtitleLanguage: 'Langue des sous-titres',
  mainCaption: 'Sous-titre principal',
  ratings: 'Évaluations',
  type: 'Type',
  dciStandard: 'Norme DCI',
  closedSubtitles: 'Sous-titres fermés',
  frameRate: 'Fréquence d’images',
  audioFormats: 'Formats audio',
  resolution: 'Résolution',
  closedCaptions: 'Sous-titres fermés',
  stereoType: 'Type stéréo',
  aspectRatio: 'Format d’image',
};
